exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".languageSelector-module-language-selector-desktop{position:fixed;right:32px;bottom:32px;z-index:1000}.languageSelector-module-language-selector-mobile{z-index:1000;max-height:1px;margin-bottom:10rem;margin-left:.8rem}", ""]);

// Exports
exports.locals = {
	"language-selector-desktop": "languageSelector-module-language-selector-desktop",
	"language-selector-mobile": "languageSelector-module-language-selector-mobile"
};